"use client";

import { useContext } from "react";
import { AuthContext } from "../../../../../apps/dotcom/src/components/auth-wrapper/auth-context";

import {
  Authenticated,
  type AuthenticatedProperties,
} from "./true-blue/authenticated";
import {
  Unauthenticated,
  type UnauthenticatedProperties,
} from "./true-blue/unauthenticated";

import { enhanceUserData } from "../../../helpers/user-data/enhance-user-data";

export type CustomerDetails = {
  contact: {
    addresses: {
      addressType: string;
      city: string;
      country: string;
      postcode: string;
      state: string;
      street1: string;
      street2: string;
    }[];
    emails: string[];
    phones: {
      areaCode: string;
      countryCode: string;
      extension: string;
      number: string;
      type: string;
    }[];
  };
  creditCards: {
    cardCode: string;
    expirationDate: string;
    holderName: string;
    number: string;
    type: string;
  }[];
  dateOfBirth: string;
  firstName?: string | undefined;
  gender: string;
  loyaltyDetails: {
    accountBalance?: number;
    airline?: string;
    benefitsDetails?: string[];
    cobrandCardCodes?: string[];
    membershipID: string;
    membershipTier:
      | "MEMBER"
      | "MOSAIC_1"
      | "MOSAIC_2"
      | "MOSAIC_3"
      | "MOSAIC_4"
      | "MOSAIC_5";
    tiles?: number;
  };
  lastName?: string | undefined;
  prefix?: string | undefined;
  profileId: string;
  profileImage?: string | undefined;
  profileImageType?: string | undefined;
  travelBankDetails?:
    | {
        accountNumber: string;
        balance?:
          | {
              amount: string;
              currency: string;
            }
          | undefined;
      }
    | undefined;
};
export type HeaderTrueBlueProperties = {
  creditProfileMenu: AuthenticatedProperties["creditProfileMenu"];
  loggedInMenu: AuthenticatedProperties["loggedInMenu"];
  loggedOutMenu: UnauthenticatedProperties;
  useAuth?: boolean;
};
export const HeaderTrueBlue = ({
  creditProfileMenu,
  loggedInMenu,
  loggedOutMenu,
  useAuth,
}: HeaderTrueBlueProperties) => {
  const hasAuthToken = useContext(AuthContext).IS_TOKEN_STORED;
  const customerDetails = useContext(AuthContext).PROFILE?.customerDetails;
  const isCreditProfile = useContext(AuthContext).IS_CREDIT_PROFILE_USER;

  const isSignedIn = useAuth && hasAuthToken && customerDetails;

  return isSignedIn ? (
    <Authenticated
      creditProfileMenu={creditProfileMenu}
      customerDetails={enhanceUserData({ customerDetails, isCreditProfile })}
      isCreditProfile={isCreditProfile}
      loggedInMenu={loggedInMenu}
    />
  ) : (
    <Unauthenticated {...loggedOutMenu} />
  );
};

HeaderTrueBlue.displayName = "Header.TrueBlue";
